import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '../App';

export default function PublicLayout({ children }) {
  const { login } = useAuth();

  return (
    <div className="min-h-screen bg-neutral-50">
      <header className="bg-white border-b border-neutral-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 bg-neutral-900 rounded-sm flex items-center justify-center text-white font-bold text-xs">RE</div>
            <span className="font-bold text-lg" style={{ fontFamily: 'Outfit' }}>Research Exchange</span>
          </Link>
          <div className="flex items-center gap-3">
            <button onClick={() => login('researcher')} className="btn-researcher px-4 py-2 text-sm font-medium flex items-center gap-1.5">
              Join as Researcher <ArrowRight size={14} />
            </button>
            <button onClick={() => login('client')} className="btn-client px-4 py-2 text-sm font-medium flex items-center gap-1.5">
              Join as Client <ArrowRight size={14} />
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
}
